module.exports = __webpack_public_path__ + "media/icons/fast-cdc05089.png";